import { queries } from "../../shared/queries";
import { buildUserGroupMemberships } from "../../shared/rbac/grantQueries";
import { useQuery } from "@rocicorp/zero/react";

export function useUserGroupMemberships(options?: { enabled?: boolean }) {
  const { enabled = true } = options ?? {};
  const [groups, result] = useQuery(
    enabled ? queries.allUserGroupMemberships() : undefined
  );

  const memberships = buildUserGroupMemberships(
    (groups ?? []).flatMap((group) =>
      group.roleGrantsAsScope.map((grant) => ({
        userId: grant.userId,
        scopeId: group.id,
      }))
    )
  );
  return { memberships, loaded: !enabled || result.type === "complete" };
}
